import axios from 'axios'
import { ApiConfig } from '../../../config/api'

export interface PickingValidationSkuDetailBatchInfoDto {
  batchId: number
  batchNumber: string
  expirationDate: string | null
  pickedQty: number
}

export interface BatchesFilterDto {
  PageIndex?: number
  PageSize?: number
}

export const getBatchesFromPickingRouteDetail = (
  pickingRouteDetailId: number,
  pageIndex: number = 0,
  pageSize: number = 50
) => {
  const url = new URL(`${ApiConfig.PickingRouteDetailsApi}/${pickingRouteDetailId}/batches`)
  
  url.searchParams.set('PageIndex', pageIndex.toString())
  url.searchParams.set('PageSize', pageSize.toString())
  
  return axios.get(url.toString())
}